module.exports = __webpack_public_path__ + "img/arrow_up_grey_color.93144127.svg";